import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'consoleLog'})
export class ConsoleLogPipe implements PipeTransform {
    transform(...args: any[]): any {
        console.log(args);
        return args;
    }
}
